/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiCursorAIcon20Solid = forwardRef('UiCursorAIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M7.203 2.496c-1.317-.99-3.2-.051-3.202 1.597l-.014 12.324c-.002 1.922 2.444 2.74 3.599 1.204l2.952-3.926a.5.5 0 0 1 .4-.2l4.912.006c1.922.002 2.74-2.444 1.205-3.599L7.203 2.496Z" })));
});
